<template>
    <div>
        <loading
            :active.sync="loadingApp"
            :can-cancel="false"
            :is-full-page="true"
            :color="'#0B8BCC'"
            :loader="'dots'"
            :opacity="0.7"
            :lock-scroll="true"
        ></loading>
        <Toast
            :show.sync="toast.show"
            :message="toast.message"
            :tipe="toast.tipe"
            @close="toast.show = false"
            :position="toast.position"
            :icon="toast.icon"
        ></Toast>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light">
            <div class="left">
                <a
                    href="Javascript:;"
                    class="headerButton"
                    @click="$router.go(-1)"
                >
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </a>
            </div>
            <div class="pageTitle">Detail Downline</div>
        </div>
        <!-- * App Header -->
        <div id="appCapsule" v-if="loadingApp == false">
            <div
                class="section curved-header pt-1"
                style="--height-curved: 100px"
            >
                <div class="wallet-card">
                    <div class="col-12 text-primary">
                        <div
                            style="
                                color: #17273e;
                                font-weight: 500;
                                display: block;
                                font-size: 13px;
                            "
                        >
                            <span>Nama Downline</span>
                        </div>
                        <h3 class="text-primary truncate-text">
                            <span>{{ downline_data.name }}</span>
                        </h3>
                    </div>
                    <div class="balance">
                        <div class="col-6 text-left">
                            <div
                                class="title"
                                style="display: flex; align-items: center"
                            >
                                <span class="mr-1">Total Transaksi</span
                                ><ion-icon
                                    name="information-circle-outline"
                                    style="font-size: 18px"
                                    class="text-primary"
                                    @click="
                                        infoTotalTransaksi(
                                            'total_transaksi',
                                            'show'
                                        )
                                    "
                                ></ion-icon>
                            </div>
                            <h1 class="total">
                                <span>{{
                                    downline_data.total_transcation
                                }}</span>
                            </h1>
                        </div>
                        <div class="col-6 text-right">
                            <div>
                                <div
                                    class="badge badge-success-custom badge-outline"
                                    style="padding: 8px 10px"
                                    v-if="downline_data.status == 'ACTIVE'"
                                >
                                    <b>Aktif</b>
                                </div>
                                <div
                                    class="badge badge-danger-custom badge-outline"
                                    style="padding: 8px 10px"
                                    v-else-if="
                                        downline_data.status == 'INACTIVE'
                                    "
                                >
                                    <b>Belum Aktif</b>
                                </div>
                                <div
                                    class="badge badge-grey-custom badge-outline"
                                    style="padding: 8px 10px"
                                    v-else-if="downline_data.status == 'DORMAN'"
                                >
                                    <b>Dorman</b>
                                </div>
                            </div>
                            <div style="margin-top: 5px">
                                <div
                                    class="badge badge-success-custom badge-outline"
                                    style="padding: 8px 10px"
                                    v-if="
                                        downline_data.downline_account_verified
                                    "
                                >
                                    <b>Terverifikasi</b>
                                </div>
                                <div
                                    class="badge badge-warning-custom badge-outline"
                                    style="padding: 8px 10px"
                                    v-else
                                >
                                    <b>Belum Verifikasi</b>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="wallet-footer">
                        <button
                            class="btn btn-warning btn-block text-nowrap"
                            @click="openWhatsApp(false)"
                            v-if="!downline_data.downline_account_verified"
                        >
                            <ion-icon name="notifications"></ion-icon>
                            Ingatkan Downline untuk Verifikasi
                        </button>
                        <button
                            class="btn btn-primary btn-block text-nowrap"
                            @click="openWhatsApp(true)"
                            v-else
                        >
                            <ion-icon name="notifications"></ion-icon>
                            Ajak Downline Maksimalkan Transaksi
                        </button>
                    </div>
                </div>
            </div>

            <div class="section full" style="margin-top: 120px">
                <div
                    class="alert alert-warning-custom ml-2 mr-2"
                    v-if="!downline_data.downline_account_verified"
                >
                    <p class="mb-0">
                        Total Komisi untuk Target Agen Affiliate Plus tidak akan
                        tercatat jika downline kamu belum melakukan verifikasi
                        akun .
                    </p>
                </div>
                <!-- <div class="ml-2 mr-2 mt-2">
                    <h5 style="font-weight:bold;" class="mb-0">
                        Riwayat Komisi dari Transaksi Downline
                    </h5>
                </div>
                <div v-if="downline.data.length > 0">
                    <ul class="listview image-listview-product inset">
                        <li v-for="item in downline.data" :key="item.id">
                            <div class="item pl-3 pr-3">
                                <div class="in">
                                    <div style="width: 90%;">
                                        <h4>{{ item.name }}</h4>
                                        <footer style="line-height: 18px;">
                                            Bergabung pada<br />
                                            <b>{{
                                                dateMutation(item.created_at)
                                            }}</b>
                                        </footer>
                                    </div>
                                    <span class="text-muted text-right">
                                        <div
                                            class="badge badge-success-custom badge-outline"
                                            style="padding: 8px 10px;"
                                            v-if="
                                                item.account_verified_approved !=
                                                    null
                                            "
                                        >
                                            <b>Aktif</b>
                                        </div>
                                        <div
                                            class="badge badge-warning-custom badge-outline"
                                            style="padding: 8px 10px;"
                                            v-else
                                        >
                                            <b>Belum Verifikasi</b>
                                        </div>
                                    </span>
                                </div>
                                <div class="ml-2 right">
                                    <div class="icon" style="color: #a9abad;">
                                        <ion-icon
                                            name="chevron-forward-outline"
                                        ></ion-icon>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <div class="m-2 text-center" v-if="downline.next_page_url">
                        <ButtonLoader
                            :loading="loadingButton"
                            :styled="'btn btn-primary rounded mr-1 mb-1'"
                            @click.native="
                                paginateDownline(downline.next_page_url)
                            "
                            >Lihat lebih banyak</ButtonLoader
                        >
                    </div>
                </div>
                <div class="text-center" style="margin-top:50px;" v-else>
                    <img
                        :src="require('@/assets/image/empty.webp')"
                        alt="404"
                        class="w-75 mb-3"
                    /><br />
                    <i>Data belum tersedia</i>
                </div> -->
            </div>
        </div>
        <action-sheet ref="info" :title="'Informasi'" :inset="true">
            <p style="line-height: 17px">
                <small>{{ infoActionSheet }}</small>
            </p>
        </action-sheet>
    </div>
</template>
<script>
    import $axios from '../../api.js';
    import { mapActions, mapState } from 'vuex';
    import moment from 'moment';
    export default {
        data() {
            return {
                loadingApp: true,
                loadingButton: false,
                downline_data: {
                    id: '',
                    name: '',
                    downline_account_verified: false,
                    total_transcation: '0',
                },
                infoActionSheet: '',
            };
        },
        computed: {
            ...mapState(['toast', 'VUE_ENV', 'customer', 'setting']),
        },
        methods: {
            ...mapActions(['getCustomer', 'getSetting']),
            getDownlineDetail() {
                $axios
                    .get(
                        '/referral/downline/' +
                            this.$route.params.id +
                            '/detail'
                    )
                    .then(response => {
                        this.downline_data = response.data.data;
                        this.loadingButton = false;
                        this.loadingApp = false;
                    })
                    .catch(() => {
                        this.loadingButton = false;
                        this.loadingApp = false;
                    });
            },
            dateMutation(date) {
                return moment(date).format('D MMM YYYY H:mm:ss');
            },
            infoTotalTransaksi(type, value) {
                this.infoActionSheet = '';
                if (type == 'total_transaksi') {
                    this.infoActionSheet =
                        'Total transaksi adalah total jumlah transaksi berhasil yang dilakukan oleh downline, data yang ditampilkan adalah data pada bulan berjalan.';
                }
                let element = this.$refs.info.$el;
                window.$(element).modal(value);
            },
            openWhatsApp(verified) {
                let message;
                if (verified) {
                    message =
                        '🔥 Jangan sampai ketinggalan! ' +
                        this.VUE_ENV.VUE_APP_NAME +
                        ' punya banyak promo menarik dan penawaran spesial buat kamu 🎉. Maksimalkan transaksimu sekarang dan nikmati keuntungan lebih banyak! 💰✨ Semakin sering transaksi, semakin cuan! 🚀';
                } else {
                    message =
                        '✨ Yuk, verifikasi akun ' +
                        this.VUE_ENV.VUE_APP_NAME +
                        ' sekarang! 🔐 Dengan verifikasi, akun kamu lebih aman dan bebas risiko kehilangan ✅. Tenang, data pribadimu 100% aman dan tidak akan disalahgunakan 🛡️. ' +
                        this.VUE_ENV.VUE_APP_NAME +
                        ' sudah terdaftar sebagai PSE Komdigi Republik Indonesia 🏛️, jadi gak perlu khawatir! 🚀 Ayo verifikasi sekarang! 🎉';
                }
                const encodedMessage = encodeURIComponent(message); // Encode pesan
                const url = `https://wa.me/?text=${encodedMessage}`; // Buat URL
                window.open(url, '_blank'); // Buka di tab baru
            },
        },
        mounted() {
            this.getDownlineDetail();
        },
        destroyed() {
            this.$store.commit('RESET_TOAST');
        },
    };
</script>
<style>
    .truncate-text {
        white-space: nowrap; /* Mencegah teks melompat ke baris baru */
        overflow: hidden; /* Menyembunyikan teks yang melebihi container */
        text-overflow: ellipsis; /* Menambahkan ... di akhir teks yang terpotong */
        max-width: 100%; /* Sesuaikan dengan lebar maksimal yang diinginkan */
    }
</style>
